import axiosInstance from "../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const saleURL = `api/v1/sales-app/sales-invoice`;

//obtaining the paginated data
export const getSale = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${saleURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllSale = () => axiosInstance.get(`${saleURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageSale = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${saleURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);
// get by id
export const getSaleById = (id) => axiosInstance.get(`${saleURL}/retrieve/${id}`);

//creating function
export const createSale = (body) => axiosInstance.post(`api/v1/sales-app/sales-invoice-main/create`, body);
//updating function
export const updateSale = (id, body) => axiosInstance.patch(`${saleURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${saleURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};
